const TRANSACTION_BY_CAMPAIGN_REQUEST = 'TRANSACTION_BY_CAMPAIGN_REQUEST';
const TRANSACTION_BY_CAMPAIGN_SUCCESS = 'TRANSACTION_BY_CAMPAIGN_SUCCESS';
const TRANSACTION_BY_CAMPAIGN_FAIL = 'TRANSACTION_BY_CAMPAIGN_FAIL';

export const transactionActions = {
  TRANSACTION_BY_CAMPAIGN_REQUEST,
  TRANSACTION_BY_CAMPAIGN_SUCCESS,
  TRANSACTION_BY_CAMPAIGN_FAIL
}
